/* eslint-disable */
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useMemo } from 'react'
import styled from 'styled-components'
import { isAddress } from 'utils'
import LogoLoader from './LogoLoader'

const StyledLogo = styled(LogoLoader)<{ size: string; firstimg?: any }>`
  position: relative;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: ${({ size }) => size};
  /* box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.075); */
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  margin-right: ${({ firstimg }) => firstimg && '-6px'};
  z-index: ${({ firstimg }) => (firstimg ? '4' : '3')};
`

export const CurrencyLogo: React.FC<
  React.PropsWithChildren<{
    address?: string
    symbol?: string
    size?: string
    firstimg?: any
  }>
> = ({ address, symbol, size = '24px', firstimg = 'false', ...rest }) => {
  const { chainId } = useActiveWeb3React()
  const src = useMemo(() => {
    // const checksummedAddress = isAddress(address)
    if (address && symbol) {
      // return `https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/${checksummedAddress}/logo.png`
      // return `https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/${chainId}-${address.toLowerCase()}-${symbol.toLowerCase()}.png`
      return `https://images.noahark.io/image/${chainId}-${address.toLowerCase()}-${symbol.toLowerCase()}.png`
    }
    return null
  }, [address, symbol, chainId])

  return <StyledLogo size={size} src={src} alt="token logo" firstimg={firstimg} {...rest} />
}

const DoubleCurrencyWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 32px;
`

interface DoubleCurrencyLogoProps {
  token0?: {
    name?: string
    symbol: string
    address: string
  }
  token1?: {
    name?: string
    symbol: string
    address: string
  }
  size?: number
}

export const DoubleCurrencyLogo: React.FC<React.PropsWithChildren<DoubleCurrencyLogoProps>> = ({
  token0,
  token1,
  size = 16,
}) => {
  return (
    <DoubleCurrencyWrapper>
      {token0?.address && token0?.symbol && (
        <CurrencyLogo address={token0?.address} symbol={token0?.symbol} size={`${size.toString()}px`} firstimg="true" />
      )}
      {token1?.address && token1?.symbol && (
        <CurrencyLogo address={token1?.address} symbol={token1?.symbol} size={`${size.toString()}px`} />
      )}
    </DoubleCurrencyWrapper>
  )
}
